export enum CashDirection {
  Inflows,
  Outflows,
}
